
































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";

// const gravBaseUrl = process.env.VUE_APP_GRAV_BASE_URL;
const gravBaseUrl = 'https://g.cyurica.biz/cyurica/'

export default createComponent({
  setup(props: {}, context: SetupContext) {

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const loadedFlag = ref<boolean>(false);

    const member = computed(() => memberStore.member);

    const attachment2Flag = ref<boolean>(false);

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();

      // 別紙2対象企業
      const attachment2Compnay = [
        '0000023063', // バリプラ
        '0000050156', // 株式会社ドライバンク
        '0000050161',	// 株式会社T-1SecurityService
        '0000050166',	// 株式会社47PLANNING
        '0000050168',	// 株式会社Ash
        '0000050183',	// 株式会社LOGINEXUS
        '0000050204',	// 株式会社エムズ
        '0000050207',	// 株式会社セーフティユニオン
      ];

      // 所属企業が対象企業かチェック
      for (const company of member.value.company_list) {
        if(attachment2Compnay.includes(company["company_code"])) {
          attachment2Flag.value = true;
          break;
        }     
      }
      loadedFlag.value = false;
    });


    return {
      gravBaseUrl,
      attachment2Flag,
      loadedFlag
    };
  },
  components: {}
});
